export default "__VITE_ASSET__CjYv2c2G__"